import { render } from "./MorningExercise.vue?vue&type=template&id=0d1e78de&scoped=true"
import script from "./MorningExercise.vue?vue&type=script&lang=js"
export * from "./MorningExercise.vue?vue&type=script&lang=js"

import "./MorningExercise.vue?vue&type=style&index=0&id=0d1e78de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1e78de"]])

export default __exports__